import React from "react";
import './About.css'

const Block = () => {
    return (  
        
        <div className="Block">
            <h2>ABOUT</h2>
            <p>A poised young lad, eager to broaden my knowledge and embrace innovative concepts.<br/>With unwavering dedication, I actively pursue
                opportunities to challenge myself<br/>and excel in my field.
            </p>
        </div>
    );
}
 
export default Block;